import { gql } from '@apollo/client';

export const GENERATE_APPLICATIONS_REPORT = gql`
  query ApplicationsReport($input: ApplicationsReportInput!) {
    applicationsReport(input: $input) {
      labels
      keys
      points
      data {
        values
      }
      summary {
        title
        value
      }
    }
  }
`;

export const GENERATE_APPLICATIONS_REPORT_FILE = gql`
  query ApplicationsReport($input: ApplicationsReportInput!) {
    applicationsReport(input: $input) {
      url
    }
  }
`;
